// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";

function isUpdateWaypointActive(orderStatue) {
  return orderStatue < 4;
}

function getCurrentWaypointStatus(orderDetails) {
  return orderDetails._0.has_waypoints;
}

function getAdditionalWaypointEligible(orderDetails) {
  return orderDetails._0.additional_waypoints_eligible;
}

function getAdditionalWaypointStatus(orderDetails) {
  return orderDetails._0.additional_waypoints_allowed;
}

var validators_hasAdditionalWayPoint = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      if (metadata.orderStatus < 4 && metadata.isFormActive) {
        if (param.hasAdditionalWayPoint) {
          return {
                  TAG: /* Ok */0,
                  _0: true
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: false
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: metadata.orderDetails._0.additional_waypoints_allowed
              };
      }
    })
};

var validators_hasWayPoint = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      if (metadata.orderStatus < 4 && metadata.isFormActive) {
        if (param.hasWayPoint) {
          return {
                  TAG: /* Ok */0,
                  _0: true
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: false
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: metadata.orderDetails._0.has_waypoints
              };
      }
    })
};

var validators = {
  hasAdditionalWayPoint: validators_hasAdditionalWayPoint,
  hasWayPoint: validators_hasWayPoint
};

function initialFieldsStatuses(_input) {
  return {
          hasAdditionalWayPoint: /* Pristine */0,
          hasWayPoint: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            hasAdditionalWayPoint: /* Pristine */0,
            hasWayPoint: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.hasAdditionalWayPoint;
  var match_0 = match ? match._0 : Curry._2(validators.hasAdditionalWayPoint.validate, input, metadata);
  var match$1 = fieldsStatuses.hasWayPoint;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.hasWayPoint.validate, input, metadata);
  var hasAdditionalWayPointResult = match_0;
  var hasAdditionalWayPointResult$1;
  if (hasAdditionalWayPointResult.TAG === /* Ok */0) {
    var hasWayPointResult = match_0$1;
    if (hasWayPointResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                hasWayPoint: hasWayPointResult._0,
                hasAdditionalWayPoint: hasAdditionalWayPointResult._0
              },
              fieldsStatuses: {
                hasAdditionalWayPoint: /* Dirty */{
                  _0: hasAdditionalWayPointResult,
                  _1: /* Shown */0
                },
                hasWayPoint: /* Dirty */{
                  _0: hasWayPointResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    hasAdditionalWayPointResult$1 = hasAdditionalWayPointResult;
  } else {
    hasAdditionalWayPointResult$1 = hasAdditionalWayPointResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            hasAdditionalWayPoint: /* Dirty */{
              _0: hasAdditionalWayPointResult$1,
              _1: /* Shown */0
            },
            hasWayPoint: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurHasAdditionalWayPointField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.hasAdditionalWayPoint, validators_hasAdditionalWayPoint, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  hasAdditionalWayPoint: status,
                                  hasWayPoint: init.hasWayPoint
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurHasWayPointField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.hasWayPoint, validators_hasWayPoint, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  hasAdditionalWayPoint: init.hasAdditionalWayPoint,
                                  hasWayPoint: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateHasAdditionalWayPointField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.hasAdditionalWayPoint, state.submissionStatus, validators_hasAdditionalWayPoint, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            hasAdditionalWayPoint: status,
                                            hasWayPoint: init.hasWayPoint
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateHasWayPointField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.hasWayPoint, state.submissionStatus, validators_hasWayPoint, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            hasAdditionalWayPoint: init.hasAdditionalWayPoint,
                                            hasWayPoint: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                hasAdditionalWayPoint: /* Pristine */0,
                                hasWayPoint: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                hasAdditionalWayPoint: /* Pristine */0,
                                hasWayPoint: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateHasAdditionalWayPoint: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHasAdditionalWayPointField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateHasWayPoint: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHasWayPointField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurHasAdditionalWayPoint: (function (param) {
              return Curry._1(dispatch, /* BlurHasAdditionalWayPointField */0);
            }),
          blurHasWayPoint: (function (param) {
              return Curry._1(dispatch, /* BlurHasWayPointField */1);
            }),
          hasAdditionalWayPointResult: Formality.exposeFieldResult(state.fieldsStatuses.hasAdditionalWayPoint),
          hasWayPointResult: Formality.exposeFieldResult(state.fieldsStatuses.hasWayPoint),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.hasAdditionalWayPoint || match.hasWayPoint) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var HasWaypointForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getPayload(formData, crn, order_updated_at) {
  if (formData !== undefined) {
    return {
            crn: crn,
            has_waypoint: formData.hasWayPoint,
            order_updated_at: order_updated_at
          };
  }
  
}

function getInitialInput(orderDetails) {
  return {
          hasWayPoint: orderDetails._0.has_waypoints,
          hasAdditionalWayPoint: !orderDetails._0.additional_waypoints_allowed
        };
}

var HasWaypointFormHelper = {
  getPayload: getPayload,
  getInitialInput: getInitialInput
};

export {
  isUpdateWaypointActive ,
  getCurrentWaypointStatus ,
  getAdditionalWaypointEligible ,
  getAdditionalWaypointStatus ,
  HasWaypointForm ,
  HasWaypointFormHelper ,
  
}
/* react Not a pure module */
